/* eslint-disable @typescript-eslint/no-explicit-any */
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';

type IconProps = {
  icon?: string | any;
  fallback: any;
};

export const RenderIcons = ({ icon, fallback }: IconProps) => {
  if (!icon) {
    return fallback;
  }

  if (icon == 'edit') {
    return <FaEdit size={10} />;
  }
  if (icon == 'trash') {
    return <FaTrash size={10} />;
  }
  if (icon == 'plus') {
    return <FaPlus size={10} />;
  }

  // Assume icon is a svg string
  if (typeof icon == 'string') {
    return <div dangerouslySetInnerHTML={{ __html: icon }} style={{ width: 14 }} />;
  } else if (typeof icon == 'object') {
    return icon;
  }
  return fallback;
};
